import {
  FileSpreadsheet,
  type LucideIcon,
  Scale,
  Settings,
  SlidersHorizontal,
  Workflow,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";

type CardConfigurare = {
  titlu: string;
  descriere: string;
  url: string;
  icon: LucideIcon;
};

const CARDURI: CardConfigurare[] = [
  {
    titlu: "Mapare CAEN",
    descriere:
      "Corespondența coduri CAEN → servicii NIS2, pe versiune, cu ambiguitate și explicații.",
    url: "/administrare/targetare/mapare",
    icon: Workflow,
  },
  {
    titlu: "Scoruri",
    descriere:
      "Scorurile scenariilor de ambiguitate folosite la calculul ratingului de încredere.",
    url: "/administrare/targetare/scoruri",
    icon: SlidersHorizontal,
  },
  {
    titlu: "Reguli",
    descriere: "Regulile de clasificare și pragurile de dimensiune.",
    url: "/administrare/targetare/reguli",
    icon: Scale,
  },
  {
    titlu: "Liste (surse)",
    descriere:
      "Configurarea surselor de liste oficiale și neoficiale (URL, metodă, actualizare automată).",
    url: "/administrare/targetare/liste",
    icon: FileSpreadsheet,
  },
  {
    titlu: "Setări",
    descriere:
      "Cheile simple din targetare.setare: targetare activă, TTL cache ANAF, prag de selecție, curs RON/EUR.",
    url: "/administrare/configurare/setari",
    icon: Settings,
  },
];

export default function Prezentare() {
  return (
    <div className="space-y-6">
      <p className="max-w-3xl text-sm text-muted-foreground">
        Regruparea nu mută codul paginilor existente — fiecare card duce la
        pagina ei, neschimbată. Singura pagină nouă este Setări.
      </p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {CARDURI.map((c) => (
          <Link key={c.url} to={c.url}>
            <Card className="h-full transition-colors hover:border-ds-blue-300 hover:bg-ds-blue-50/40">
              <CardContent className="flex flex-col gap-2 p-4">
                <c.icon className="h-5 w-5 text-ds-blue-700" />
                <p className="font-heading font-semibold">{c.titlu}</p>
                <p className="text-sm text-muted-foreground">{c.descriere}</p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
